import React from "react";
import { Box, Typography, Divider, Link } from "@mui/material";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import { useTranslation } from "react-i18next";

const ChatMessage = ({ type, isClient, text, date, file, download }) => {
  const { t, i18n } = useTranslation();

  return (
    <Box
      className="flex my-5"
      sx={{
        justifyContent: isClient ? "flex-end" : "flex-start",
        direction: i18n.dir(), // let direction be RTL or LTR for content only
      }}
    >
      <Box
        sx={{
          maxWidth: "80%",
          bgcolor: isClient ? "#6E4084" : "grey.300",
          color: isClient ? "white" : "black",
          px: 2,
          py: 1,
          borderRadius: 4,
          borderTopLeftRadius: isClient ? 4 : 15,
          textAlign:"left"
        }}
      >
        <Typography variant="subtitle2" fontWeight="bold">
          {isClient ? t("Support.You") : t("Support.Support")}
        </Typography>

        <Divider sx={{ my: 1, bgcolor: isClient ? "white" : "grey.500" }} />

        <Typography variant="body1" sx={{ wordWrap: "break-word" }}>
          {text}
        </Typography>

        {file && (
          <Box mt={1}>
            <Link
              href={`https://api.copysa.ir/api/Ticket/Download/${download}`}
              underline="always"
              rel="noopener noreferrer"
              sx={{
                color: isClient ? "white" : "primary.main",
                display: "flex",
                alignItems: "center",
                gap: 0.5,
              }}
            >
              <AttachFileIcon fontSize="small" />
              {t("Support.viewfile")}
            </Link>
          </Box>
        )}

        <Divider sx={{ my: 1, bgcolor: isClient ? "white" : "grey.500" }} />

        <Typography
          variant="caption"
          sx={{ display: "block", textAlign: "end" }}
        >
          {date}
        </Typography>
      </Box>
    </Box>
  );
};

export default ChatMessage;
